import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import colors from './colors';

function withOffset(options) {
  return typeof options.offset !== 'undefined';
}

export function focusOutline(options) {
  var borderColor = options.borderColor,
      boxShadow = options.boxShadow,
      _options$borderWidth = options.borderWidth,
      borderWidth = _options$borderWidth === void 0 ? '1px' : _options$borderWidth,
      _options$borderStyle = options.borderStyle,
      borderStyle = _options$borderStyle === void 0 ? 'solid' : _options$borderStyle;
  var outline = {
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    boxShadow: boxShadow
  };

  if (withOffset(options)) {
    var _options$borderRadius = options.borderRadius,
        borderRadius = _options$borderRadius === void 0 ? 0 : _options$borderRadius,
        offset = options.offset;
    return {
      '[tabindex="-1"]': {
        position: 'relative',
        ':before': _objectSpread({
          content: "''",
          position: 'absolute',
          borderRadius: borderRadius,
          top: -offset.y,
          right: -offset.x,
          bottom: -offset.y,
          left: -offset.x
        }, outline)
      }
    };
  }

  return outline;
}
export var defaultOptions = {
  borderColor: colors.primary80,
  boxShadow: "0 0 0 4 ".concat(colors.primary40),
  borderWidth: '1px',
  borderRadius: 4
};
export var defaultOffset = {
  x: 5,
  y: 3
};

/**
 * Default focus outline styles
 */
export var outlines = {
  "default": focusOutline(_objectSpread({}, defaultOptions)),
  withOffset: focusOutline(_objectSpread(_objectSpread({}, defaultOptions), {}, {
    offset: _objectSpread({}, defaultOffset)
  })),
  defaultOutline: {
    outlineWidth: 4,
    outlineStyle: 'solid',
    outlineColor: colors.primary40,
    outlineOffset: 3
  }
};
export default {
  focusOutline: focusOutline,
  defaultOptions: defaultOptions,
  defaultOffset: defaultOffset,
  outlines: outlines
};